import { Component, OnInit } from '@angular/core';
import { ContentfulService } from 'src/app/core/contentful.service';
import { Entry } from 'contentful';
import { NavbarService } from '../../core/navbar.service';
import { SeoService } from '../../core/seo.service';
@Component({
  selector: 'app-exhibits',
  templateUrl: './exhibits.component.html',
  styleUrls: ['./exhibits.component.css']
})
export class ExhibitsComponent implements OnInit {

  public exhibits: Entry<any>[] = [];
  constructor(
    private seo: SeoService,
    private contentfulService: ContentfulService,
    public nav: NavbarService
  ) { }

  ngOnInit() {
    this.nav.show();
    this.seo.updateTags({
      title: 'Museum Exhibits',
      description: 'Explore permanent and rotating exhibits at Bayou Lacombe Museum including Choctaw Native American artifacts, Father Adrien Rouquette, rural Louisiana folk life, and timber mill history.',
      url: '/exhibits'
    });
    this.contentfulService.getExhibits()
    .then(exhibits => this.exhibits = exhibits);
  }

}

